import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import setPinImage01 from "@/assets/images/help/set-pin-01.png";
import setPinImage02 from "@/assets/images/help/set-pin-02.png";

export default function HelpPinSetup() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            Guide to Setting Your PIN
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-9">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Set Your Security PIN
              {"\n"}To use your card, you need to set a security PIN.
            </p>
          </div>

          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 1: Go to My Card Page
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Go to the My Card page and select the card you want to set a PIN
              for.
              {"\n\n"}Click the "Set PIN" button to proceed.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={setPinImage01}
                alt="Set PIN Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 2: Enter Your 4-Digit PIN
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              · Enter a 4-digit number.
              {"\n"} · Re-enter the same number to confirm.
              {"\n"} · Press the "Set PIN" button to complete the setup.
              {"\n\n"}Note:
              {"\n"} · Avoid easily guessable numbers (e.g., birthdates, 1234,
              etc.).
              {"\n"} · Your PIN will be used for payments and authentication.
              {"\n"} · A PIN can be reset 24 hours after it is set.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={setPinImage02}
                alt="Set PIN Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/12")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Card Status Change Guide</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
